import React from "react";
import classNames from "classnames";
import "./index.scss";

const IFrameControl = ({ value, title, onLoad, onClose }) => {
  const handleOnLoad = e => {
    onLoad && onLoad(e);
  }

  const handleOnClose = () => {
    onClose && onClose();
  }

  return (
    <div className={classNames("iFrameControl")}>
      <div className={classNames("header")}>
        <div className={classNames("title")}>{title || ""}</div>
        <div className={classNames("close")} onClick={handleOnClose}>X</div>
      </div>
      <iframe id="iframeControl" src={value} title={"iFrameControl"} sandbox="allow-scripts"
        className={classNames("iFrameItem")}
        onLoad={handleOnLoad}
      />
    </div>
  );
};

export default IFrameControl;